import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function SoftDrinksPage() {

    const heroData = [
        {
          title: "Soft Drinks & Water",
          content: "Stay refreshed with our range of soft drinks and premium water. Whether you prefer the fizz of your favorite soda or the pure simplicity of chilled water, we have options to keep you hydrated and satisfied. Perfect for any time of day!",
          image: images.SoftDrinksHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Sparkling Water",
        content: "(Local/Imported)",
        price: 0,
        image: [
          images.Water1,
        ]
      },
      {
        name: "Still Water",
        content: "(Local/Imported)",
        price: 0,
        image: [
          images.Water2,
        ]
      },
      {
        name: "Coke",
        content: "(Diet options available)",
        price: 0,
        image: [
          images.SoftDrink1,
        ]
      },
      {
        name: "Sprite",
        content: "(Diet options available)",
        price: 0,
        image: [
          images.SoftDrink2,
        ]
      },
      {
        name: "Fanta",
        content: "(Diet options available)",
        price: 0,
        image: [
          images.SoftDrink3,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Sparkling Water",
        image1: [
          images.Water1,
        ],
        content1: "",
        name2: "Coke",
        image2: [
          images.SoftDrink1,
        ],
        content2: ""
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
